export default __webpack_public_path__ + "static/Mixpanel-10f5c6bbe8a9e32be44fe9d97d5179d8.png";